import theme from "./index"

export default {
  ...theme,
  color: "#FFF",
  backgroundColor: theme.color,
}
